import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import { convertToBgImage } from 'gbimage-bridge';
const ArticleHomeComponent = props => {
  const { articleTitle, articleBackgroundImage } = props;
  const contactBgImage = convertToBgImage(articleBackgroundImage);
  return (
    <div className="full-container">
      <BackgroundImage
        {...contactBgImage}
        Tag="section"
        imgStyle={{ width: '100%' }}
        className="article-section"
        style={{ opacity: '1!important' }}
        alt='bg-image'
      >
        <div className="article-section">
          <div className="article-section-text">
            <h1 className="article-section-text-title">{articleTitle}</h1>
          </div>
        </div>
      </BackgroundImage>
    </div>
  );
};
export default ArticleHomeComponent;
